import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { AdditionalDocumentsPreview } from '@/features/ui/Steps/AdditionalDocuments/AdditionalDocuments';
import { ConfirmationOfApplication } from '@/features/ui/Steps/ConfirmationOfApplication';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';
import { InsurancePreview } from '@/features/ui/Steps/InsuranceData';
import { PersonalAndPassportDataPreview } from '@/features/ui/Steps/PersonalAndPassportData';
import { PlaceOfResidencePreview } from '@/features/ui/Steps/PlaceOfResidence';
import { WeaponWithPhotosSelectionPreview } from '@/features/ui/Steps/WeaponSelection/WeaponPhotos';

import { ConditionView, Link, StepControlPanel, Typography } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { ExpertResearchStepPreview } from '@/modules/erz/pages/services/ColdSteelStorageForCollection/ui/steps/ExpertResearchStep';

import { ROUTES } from '@/router/config';

import { FormDataType } from '@/api/types';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: FormDataType) => Promise<void>;
  shouldBeAbleToUpdateProfile: boolean;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({
  next,
  prev,
  handleGeneratePDF,
  shouldBeAbleToUpdateProfile,
}) => {
  const { watch, getValues } = useFormContext<FormDataType>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);

  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = async (): Promise<void> => {
    setIsLoading(true);

    handleGeneratePDF(getValues())
      .then(proceedNextFromConfirmation)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <WeaponWithPhotosSelectionPreview />
        <ExpertResearchStepPreview />
        <PersonalAndPassportDataPreview />
        <PlaceOfResidencePreview />
        <InsurancePreview />
        <AdditionalDocumentsPreview />
      </FormBlock>

      <ConfirmationOfApplication
        confirmLabelElement={
          <Typography>
            Я підтверджую правильність даних та ознайомлений з{' '}
            <Link isExternal to={ROUTES.PERSONAL_DATA}>
              політикою обробки персональних даних
            </Link>
          </Typography>
        }
        shouldBeAbleToUpdateProfile={shouldBeAbleToUpdateProfile}
      />

      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
